<li class="menu-item" aria-haspopup="true">
  <a
    href="javascript:;"
    [routerLink]="['/' + navigateTo]"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: exactMatch }"
    [class.active]="isExtraActive"
    class="menu-link"
    (click)="commonService.showSidenav(); navigateToUrl(navigateTo)"
    #routerLinkActive="routerLinkActive"
  >
    <span class="menu-text">
      <!-- @if (navigationLoader) {
        <app-spinner [diameter]="14"></app-spinner>
      } -->
      <span class="icon-container">
        <app-svg-icon
          class="icon-active"
          [icon]="'assets/images/side-nav-items/' + image + '-active.svg'"
          [blank]="true"
        />
        <app-svg-icon
          class="icon-inactive"
          [icon]="'assets/images/side-nav-items/' + image + '-not-active.svg'"
          [blank]="true"
        />
      </span>
      {{ label }}
    </span>
  </a>
</li>
